import React, { useEffect, useState } from 'react'
import { MEDIA_BASE_URL, buildGalleryImages } from './Gallery'
import { resolveMediaSrc } from './RichHtml'
import './RecentFlightLogs.css'

function formatDate(d) {
  if (!d) return ''
  try {
    return new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
  } catch {
    return ''
  }
}

/**
 * One flight-log card. Uses the log's featured_image if set; otherwise falls
 * back to the first image from its gallery folder.
 */
function FlightLogCard({ log }) {
  // Thumbnail fetched from the gallery manifest (only used when there's no
  // featured image). The featured-image thumb is derived during render below.
  const [fetchedThumb, setFetchedThumb] = useState(null)

  useEffect(() => {
    // A featured image takes priority - no need to fetch the gallery.
    if (log.featured_image || !log.gallery_folder) return
    let cancelled = false
    const url = `${MEDIA_BASE_URL}/images/${log.gallery_folder.split('/').map(encodeURIComponent).join('/')}/manifest.json`
    fetch(url)
      .then((r) => (r.ok ? r.json() : []))
      .then((files) => {
        if (cancelled || !Array.isArray(files) || files.length === 0) return
        const first = buildGalleryImages(log.gallery_folder, [files[0]])[0]
        setFetchedThumb(first?.thumb || first?.src || null)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [log.featured_image, log.gallery_folder])

  const thumb = log.featured_image ? resolveMediaSrc(log.featured_image) : fetchedThumb

  return (
    <a href={`/flight-logs/${log.log_id}`} className="fl-card">
      {thumb && (
        <div className="fl-card-thumb">
          <img src={thumb} alt="" loading="lazy" />
        </div>
      )}
      <div className="fl-card-body">
        <h3>{log.title}</h3>
        {log.flight_date && <span className="fl-card-date">{formatDate(log.flight_date)}</span>}
        {log.teaser && <p className="fl-card-teaser">{log.teaser}</p>}
        <span className="fl-card-link">Read more →</span>
      </div>
    </a>
  )
}

/**
 * Homepage "Recent Flight Logs" - the 3 newest logs (from the homepage API),
 * each showing a teaser + optional gallery thumbnail, linking to the article.
 */
function RecentFlightLogs({ logs }) {
  if (!logs || logs.length === 0) return null
  return (
    <section className="recent-flightlogs">
      <h2>Recent Flight Logs</h2>
      <div className="fl-grid">
        {logs.map((log) => <FlightLogCard key={log.log_id} log={log} />)}
      </div>
      <p className="fl-all">
        <a href="/flight-logs">All flight logs</a>
      </p>
    </section>
  )
}

export default RecentFlightLogs
